import { Button } from "@/components/ui/button";
import { CaretLeft, CaretRight } from "@phosphor-icons/react";

/**
 * Pagination — server-side pagination controls.
 * Props: page, total, limit, onPageChange
 */
export default function Pagination({ page = 1, total = 0, limit = 25, onPageChange }) {
  const totalPages = Math.max(1, Math.ceil(total / limit));
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between pt-3 border-t border-[#E5E7EB] mt-3" data-testid="pagination">
      <span className="text-xs text-[#6B7280]">
        {((page - 1) * limit) + 1}–{Math.min(page * limit, total)} of {total}
      </span>
      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="sm"
          className="h-7 w-7 p-0"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          data-testid="prev-page"
        >
          <CaretLeft size={14} />
        </Button>
        {[...Array(Math.min(5, totalPages))].map((_, i) => {
          let p;
          if (totalPages <= 5) {
            p = i + 1;
          } else if (page <= 3) {
            p = i + 1;
          } else if (page >= totalPages - 2) {
            p = totalPages - 4 + i;
          } else {
            p = page - 2 + i;
          }
          return (
            <Button
              key={p}
              variant={p === page ? "default" : "outline"}
              size="sm"
              className={`h-7 w-7 p-0 text-xs ${p === page ? "bg-[#0F172A] text-white" : ""}`}
              onClick={() => onPageChange(p)}
            >
              {p}
            </Button>
          );
        })}
        <Button
          variant="outline"
          size="sm"
          className="h-7 w-7 p-0"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          data-testid="next-page"
        >
          <CaretRight size={14} />
        </Button>
      </div>
    </div>
  );
}
